export default "__VITE_ASSET__d5d6d840__"